import axios from "axios";


export default axios.create({
  
  withCredentials: true,
  //baseURL : "https://whatsbiz.online:14017/starcloudprnt",
  
 
  //baseURL:"http://192.168.1.4:8080/ac/",
   //baseURL:"https://omniqpon.net/ac/",
  baseURL:"https://juniors.omniqpon.in/ac/",
  //baseURL:"https://omniqpon.co.in:14013/starcloudprnt/",
  //baseURL : "https://omniqpon.in:14017/starcloudprnt",
  
  headers: {
    "Authorization": "***",
    'Accept': 'application/json',
    //'Content-Type': 'application/x-www-form-urlencoded',
   // 'Access-Control-Allow-Credentials': true
  },
  crossDomain: true,

});

